export type MenuGridState = 'grid' | 'no-match' | 'load-failed' | 'loading'

/**
 * Which empty state the counter's product grid shows (F-FE-N114).
 *
 * "Still loading" and "the menu walk gave up" used to render the same pulsing
 * skeleton, so a cashier whose menu had failed to load saw a screen that looked
 * busy forever, with nothing to press. A menu the counter already holds is kept
 * even when a background refresh fails — stale beats blank.
 */
export function menuGridState(input: {
  filteredCount: number
  hasSearch: boolean
  productsCount: number
  loadFailed: boolean
}): MenuGridState {
  if (input.filteredCount > 0) return 'grid'
  if (input.hasSearch) return 'no-match'
  if (input.loadFailed && input.productsCount === 0) return 'load-failed'
  return 'loading'
}
